import angular from 'angular';
import './bd-overlay-preloader.styles.scss';

export default angular.module('autoboard.backdropOverlayPreloader', [])
  .directive('bdOverlayPreloader', () => {
    'ngInject';

    return {
      restrict: 'E',
      scope: {
        title: '@',
      },
      templateUrl: require('./bd-overlay-preloader.template.html'),
    };
  })
  .name;
